import { Auth } from "aws-amplify";
import { useState } from "react";

function CustomForgotPassword() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [stage, setStage] = useState("request"); // "request" | "submit" | "success"
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const goToSignIn = async () => {
    try {
      await Auth.signOut({ global: false });
    } catch {
      // ignore errors; this resets the Authenticator UI
    }
  };

  const sendCode = async () => {
    setLoading(true);
    setError(null);
    try {
      await Auth.forgotPassword(email);
      setStage("submit");
    } catch (err) {
      setError(err.message || "Failed to send verification code");
    } finally {
      setLoading(false);
    }
  };

  const submitPassword = async () => {
    setLoading(true);
    setError(null);
    try {
      await Auth.forgotPasswordSubmit(email, code, password);
      setStage("success");
    } catch (err) {
      setError(err.message || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  const fieldContainerStyle = { maxWidth: "450px" };
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    gap: "5px",
    marginTop: "1rem",
    maxWidth: "450px",
  };

  return (
    <amplify-card>
      {stage === "request" && (
        <>
          <h3 className="amplify-heading">Reset your password</h3>

          <div style={fieldContainerStyle}>
            <amplify-field label="Email address">
              <amplify-input
                type="email"
                value={email}
                required
                placeholder="Enter your email address"
                onInput={(e) => setEmail(e.target.value)}
              />
            </amplify-field>
          </div>

          <div style={buttonContainerStyle}>
            <amplify-button variation="link" onClick={goToSignIn}>
              Back to sign in
            </amplify-button>

            <amplify-button type="button" variation="primary" loading={loading} onClick={sendCode}>
              Send verification code
            </amplify-button>
          </div>

          {error && <p className="amplify-text amplify-text--error">{error}</p>}
        </>
      )}

      {stage === "submit" && (
        <>
          <h3 className="amplify-heading">Set a new password</h3>

          <div style={fieldContainerStyle}>
            <amplify-field label="Verification code">
              <amplify-input
                value={code}
                required
                placeholder="Verification code"
                onInput={(e) => setCode(e.target.value)}
              />
            </amplify-field>

            <amplify-field label="New password">
              <amplify-input
                type="password"
                value={password}
                required
                placeholder="New password"
                onInput={(e) => setPassword(e.target.value)}
              />
              <p className="amplify-text amplify-text--hint" style={{ maxWidth: "450px" }}>
                {/* eslint-disable-next-line */}
                Password must be at least 14 characters long and contain at least 1 uppercase letter (A-Z), 1 lowercase letter (a-z), 1 number (0-9), and 1 special character (for example: ! @ # $ % ^ & *). </p>
            </amplify-field>
          </div>

          <div style={buttonContainerStyle}>
            <amplify-button variation="link" onClick={goToSignIn}>
              Back to sign in
            </amplify-button>

            <amplify-button
              type="button"
              variation="primary"
              loading={loading}
              onClick={submitPassword}
            >
              Reset password
            </amplify-button>
          </div>

          {error && <p className="amplify-text amplify-text--error">{error}</p>}
        </>
      )}

      {stage === "success" && (
        <>
          <h3 className="amplify-heading">Password reset successful</h3>
          <p className="amplify-text">
            Your password has been successfully reset. You can now sign in with your new password.
          </p>

          <div style={buttonContainerStyle}>
            <amplify-button type="button" variation="primary" onClick={goToSignIn}>
              Back to sign in
            </amplify-button>
          </div>
        </>
      )}
    </amplify-card>
  );
}

export default CustomForgotPassword;
